// action types
export const RESET_CHECKOUT_STATE = "resetCheckoutState";
export const UPDATE_CAMPAIGN = "updateCampaign";
export const UPDATE_POSTING_REQUIMENTS_VALUE =
  "updatePostingRequirementsValues";
export const UPDATE_POSTING_DURATION_DAYS = "updatePostingDurationDays";

const initialState = {
  postingDurationDays: {},
  postingRequirementsValues: {},
  campaign: {
    recruiterInfo: {
      name: "",
      emailAddress: ""
    },
    postingDetails: {
      title: "",
      description: "",
      organization: {
        name: "",
        companyLogo: ""
      },
      workingLocation: {
        addressLine1: "",
        addressLine2: "",
        postcode: "",
        city: "",
        country: "",
        allowsRemoteWork: false
      },
      yearsOfExperience: 0,
      employmentType: "",
      weeklyWorkingHours: {
        from: null,
        to: null
      },
      //
      salaryIndication: {
        period: "", //weekly, monthly
        range: {
          from: "",
          to: "",
          currency: ""
        }
      },
      jobPageUrl: "",
      applicationUrl: ""
    },
    targetGroup: {
      educationLevel: [],
      seniority: [],
      industry: [],
      jobCategory: []
    },
    orderedProducts: [],
    orderedProductsSpecs: []
  }
};

const state = Object.assign({}, initialState);

const actions = {
  [RESET_CHECKOUT_STATE](state) {
    state.commit(RESET_CHECKOUT_STATE);
  },
  [UPDATE_CAMPAIGN](state, payload) {
    state.commit(UPDATE_CAMPAIGN, payload);
  },
  [UPDATE_POSTING_REQUIMENTS_VALUE](state, payload) {
    state.commit(UPDATE_POSTING_REQUIMENTS_VALUE, payload);
  },
  [UPDATE_POSTING_DURATION_DAYS](state, payload) {
    state.commit(UPDATE_POSTING_DURATION_DAYS, payload);
  }
};

const mutations = {
  [RESET_CHECKOUT_STATE](state) {
    state.campaign = initialState.campaign;
    state.postingRequirementsValues = initialState.postingRequirementsValues;
  },
  [UPDATE_CAMPAIGN](state, payload) {
    state.campaign = { ...state.campaign, ...payload };
  },
  [UPDATE_POSTING_REQUIMENTS_VALUE](state, payload) {
    state.postingRequirementsValues = {
      ...state.postingRequirementsValues,
      ...payload
    };
  },
  [UPDATE_POSTING_DURATION_DAYS](state, payload) {
    state.postingDurationDays = {
      ...state.postingDurationDays,
      ...payload
    };
  }
};

export default {
  state,
  actions,
  mutations
};
